import { usePageLayout } from "./hooks/usePageLayout";

const DynamicFooter = () => {
  const { layout, loading } = usePageLayout();
  if (loading) return null;

  return <div dangerouslySetInnerHTML={{ __html: layout.footer.replace(/classname=/gi, "class=") }} />;
};

export default DynamicFooter;